import AppContext from "@/js/common/AppContext";
import Button from "@/js/common/ui/Button";
import Modal from "@/js/common/ui/modal/Modal";
import React from "react";
import DialogTitleBar from "../../common/DialogTitleBar";
import MbrasExistingMngDialog from "./dialog/MbrasExistingMngDialog";

const MbrasExistingMng = () => {
    const [modalOpen, setModalOpen] = React.useState(false); // 모달 열림 여부
    const [, setCallTime] = React.useState<Date>(new Date()); // 등록 완료 처리용

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="posR dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">
                    누락된 조합원 등록
                </span>
                <div className="bdt3 bdc007bff pb10"></div>
            </div>

            {/* 등록 영역 */}
            <div className="bd1 bdcDDDDDD bdrd8 bgcFAFAFA p20">
                {/* 상단 안내 */}
                <div className="dpFlx aiC jcSb">
                    <div>
                        <div className="fm-b fs20 fc333333 ls1">누락된 조합원 등록</div>
                        <div className="fm-c fs14 fc666666 ls1 mt8">
                            시스템에 누락된 기존 조합원을 확인하고 실제 가입이력을 기준으로 등록합니다.
                        </div>
                        <div className="fm-c fs13 fc4A90A4 ls1 mt5">
                            별도의 결재 절차 없이 조합원확인 후 조합원 정보를 직접 등록합니다.
                        </div>
                    </div>

                    <Button width={160} height={46} fontFamily="fm-b" fontSize={17} letterSpacing={-1} variant="styCompleteBtn" borderRadius={6} buttonClass="dpFlx aiC jcC" buttonName="등록 시작" onClickFunc={() => setModalOpen(true)} />
                </div>

                {/* 등록 단계 */}
                <div className="bgcWhite bd1 bdcDDDDDD bdrd8 p20 mt20">
                    <div className="fm-b fs14 fc333333 mb20">등록 절차</div>

                    <div className="dpFlx aiC jcC">
                        <div className="w280 taC">
                            <div className="fm-b fs18 fc007bff">01</div>
                            <div className="fm-b fs16 fc333333 mt8">조합원확인</div>
                            <div className="fm-c fs12 fc777777 mt5">성명과 휴대전화번호로 중복 여부 확인</div>
                        </div>

                        <div className="fm-c fs20 fc999999">→</div>

                        <div className="w280 taC">
                            <div className="fm-b fs18 fc007bff">02</div>
                            <div className="fm-b fs16 fc333333 mt8">조합원 · 가입정보</div>
                            <div className="fm-c fs12 fc777777 mt5">소속 및 기존 가입이력 입력</div>
                        </div>

                        <div className="fm-c fs20 fc999999">→</div>

                        <div className="w280 taC">
                            <div className="fm-b fs18 fc007bff">03</div>
                            <div className="fm-b fs16 fc333333 mt8">최종확인</div>
                            <div className="fm-c fs12 fc777777 mt5">입력정보 확인 후 조합원 등록</div>
                        </div>
                    </div>
                </div>

                {/* 안내 */}
                <div className="dpFlx aiC mt15">
                    <div className="fm-b fs13 fc007bff mr10">등록 대상</div>
                    <div className="fm-c fs13 fc666666">
                        기존에 조합에 가입되어 있으나 시스템에 등록되지 않은 조합원
                    </div>
                </div>
            </div>

            {/* 누락된 조합원 직접 등록 모달 */}
            <Modal
                modalOpen={modalOpen}
                dim={true}
                visible={true}
                titleEl={
                    <DialogTitleBar
                        title="누락된 조합원 등록 화면"
                        backgroundColor={AppContext.themeColor}
                    />
                }
                onCloseFunc={() => setModalOpen(false)}
            >
                <div className="p10">
                    <MbrasExistingMngDialog
                        setModalOpen={setModalOpen}
                        setCallTime={setCallTime}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default MbrasExistingMng;